import { PanelStore } from '../interfaces';

export namespace PaymentMethodsSelectors {
  export const getLoading = (state: PanelStore.RootState) => {
    return state.paymentMethods.loading;
  };
  export const getError = (state: PanelStore.RootState) => {
    return state.paymentMethods.error;
  };
  export const getErrorInfo = (state: PanelStore.RootState) => {
    return state.paymentMethods.errorInfo;
  };
  export const getPaymentMethodsGrouped = (state: PanelStore.RootState) => {
    return state.paymentMethods.paymentMethodsGrouped;
  };
  export const getPaymentMethodsSelected = (state: PanelStore.RootState) => {
    return state.paymentMethods.paymentMethodsSelected;
  };
  export const getShowEditCoverage = (state: PanelStore.RootState) => {
    return state.paymentMethods.showEditCoverage;
  };
  export const getAllPaymentMethods = (state: PanelStore.RootState) => {
    return state.paymentMethods.allPaymentMethods;
  };
  export const getStatusAdd = (state: PanelStore.RootState) => {
    return state.paymentMethods.statusAdd;
  };
  export const getStatusDelete = (state: PanelStore.RootState) => {
    return state.paymentMethods.statusDelete;
  };
  export const getInstallmentsCountryInfos = (state: PanelStore.RootState) => {
    return state.paymentMethods.installmentsCountryInfos;
  };
}
